import { Expose } from 'class-transformer';
export class Translations {
  @Expose({ name: 'field_required' })
  fieldRequired!: string;

  @Expose({ name: 'invalid_email' })
  invalidEmail!: string;

  @Expose({ name: 'invalid_phone_number' })
  invalidPhoneNumber!: string;

  @Expose({ name: 'next_view_button_text' })
  nextViewButtonText!: string;

  @Expose({ name: 'you_rate_thanks_to' })
  youRateThanksTo!: string;

  @Expose()
  available!: string;

  @Expose()
  gender!: string;

  @Expose()
  skip!: string;

  @Expose({ name: 'generating_error_text' })
  generatingErrorText!: string;

  @Expose({ name: 'no_data_found' })
  noDataFound!: string;

  @Expose({ name: 'problem_while_generating_review' })
  problemWhileGeneratingReview!: string;

  @Expose({ name: 'try_again' })
  tryAgain!: string;

  @Expose({ name: 'try_to_generate_again' })
  tryToGenerateAgain!: string;

  @Expose({ name: 'write_review_in_google_maps' })
  writeReviewInGoogleMaps!: string;
}
